module.exports = __webpack_public_path__ + "img/chaveiro.a2c4cb10.svg";